import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function NotificationSolid({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-6.5 -4 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <g className={theme.fill}>
          <path d="M15.8087813 4.39565283c.2826182-.44015094.4477299-.96241509.4477299-1.52392453 0-1.56015094-1.2624416-2.8250566-2.8195533-2.8250566-1.5571117 0-2.8189506 1.26490566-2.8189506 2.8250566 0 .56150944.1657143 1.08377359.4483324 1.52392453.7634909-.16966038 1.5565091-.26203774 2.3706182-.26203774.8153143 0 1.6077299.09237736 2.3718234.26203774M13.437199 31.4430792c1.9036052 0 3.4468571-1.5462641 3.4468571-3.4535849H9.99034182c0 1.9073208 1.54385458 3.4535849 3.44685718 3.4535849" />
          <path d="M23.5989797 18.8699774l-.4176-5.3826416c0-5.21962259-3.653548-9.58188674-8.5369974-10.66686788-.3953039-.08815094-.7978389-.15396226-1.2070026-.19803773-.4091636.04407547-.8123013.10988679-1.2070026.19803773C7.34632519 3.90544906 3.69337974 8.26771321 3.69337974 13.4873358l-.4182026 5.3826416c-.42001039 3.5664905-1.24918441 7.469283-2.86956883 7.469283H26.4691512c-1.620987 0-2.4501611-3.9027925-2.8701715-7.469283" />
        </g>
      </g>
    </svg>
  )
}

NotificationSolid.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
